import type { PendingTermsInfo, TermsStatusCheckResponse } from "store/api/termsApi";

function isPendingTermsInfo(value: unknown): value is PendingTermsInfo {
  if (!value || typeof value !== "object") return false;
  const termsId = (value as PendingTermsInfo).terms_id;
  return typeof termsId === "number" && Number.isFinite(termsId);
}

export function extractPendingTermsFromResponse(
  response: TermsStatusCheckResponse | undefined
): PendingTermsInfo | null {
  if (!response?.success || response.accepted !== false) return null;

  const termsInfo = response.data?.terms_info;
  if (!termsInfo || !isPendingTermsInfo(termsInfo)) return null;

  const text = String(termsInfo.text ?? "").trim();
  if (!text) return null;

  return termsInfo;
}
